import React, { useEffect, useState } from "react";
import styles from "./RechargeTransactionHistory.module.css";
import { readOrderHistory } from "../../Services/pgi";
import { connect } from "react-redux";
import { getFormattedDate } from "../../Values/utils";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router";

interface RechargeTransactionHistoryProps {
    user?: any;
}

const RechargeTransactionHistory: React.FC<RechargeTransactionHistoryProps> = ({ user }) => {
    const location = useLocation();
      const history1 = useHistory();
  const myProp:any = location?.state;
  const success= myProp?.succes||false
    const [activeFilters, setActiveFilters] = useState<string[]>(['Whatsapp']);
    const [serviceIds, setServiceIds] = useState<string[]>(["13739"]);
    const soId = user?.user_super_oid;
    const [pageNo, setPageNo] = useState('1');
    const [history, setHistory] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [nextPageAvailable, setNextPageAvailable] = useState(false);

// console.log("success",myProp.succes)
    useEffect(() => {
        const fetchHistory = async () => {
            try {
                setLoading(true);
                const data = await readOrderHistory(serviceIds, soId, pageNo,(data: any) => setNextPageAvailable(data));
                setHistory(data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching history:", error);
                setLoading(false);
            }
        };

        const fetchSuccessHistory = async () => {
            try {
                setLoading(true);
                const data = await readOrderHistory(serviceIds, soId, pageNo,(data: any) => setNextPageAvailable(data),true);
                setHistory(data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching history:", error);
                setLoading(false);
            }
        };

        {success===false ? fetchHistory():fetchSuccessHistory()}
    }, [pageNo,soId, serviceIds]);

    const handleFilterClick = (filter: string, serviceId: string) => {
        setActiveFilters((prevFilters) => {
            if (prevFilters.includes(filter)) {
                return prevFilters.filter((f) => f !== filter);
            } else {
                return [...prevFilters, filter];
            }
        });
        setServiceIds((prevServiceIds) => {
            if (prevServiceIds.includes(serviceId)) {
                return prevServiceIds.filter((f) => f !== serviceId);
            } else {
                return [...prevServiceIds, serviceId];
            }
        });
    };

    return (
        <div className={styles.Transaction}>
            <div className={styles.TransactionTitle}>Recharge History</div>
            <div className={"Breadcrums"}>
                <span 
                    className={"BreadcrumsPath"}
                    style={{cursor:"pointer"}}
                    onClick={() => {
                    history1.push("/subscriptionDetails");}}
                >Subscription</span>
                <span 
                    className={"BreadcrumsPath"}
                    style={{cursor:"pointer"}}
                    onClick={() => {
                    history1.push("/rechargeTransactionHistory");
                    }}
                >Recharge History</span>
            </div>

            <div className={styles.TransactionFilter}>
                <div className="planfilers">
                    <span
                        className={`planfiltercta ${activeFilters.includes("Whatsapp") ? "active" : ""}`}
                        onClick={() => handleFilterClick("Whatsapp", "13739")}
                    >
                        Whatsapp
                    </span>
                </div>

                <div className="planfilers">
                    <span
                        className={`planfiltercta ${activeFilters.includes("Magic Connect") ? "active" : ""}`}
                        onClick={() => handleFilterClick("Magic Connect", "13780")}
                    >
                        Magic Connect 
                    </span>
                </div>

                {/* <div className={styles.TransactionDateTime}>
                    <div className={styles.TransactionDate}>12 Jan 2023</div>
                    <div className={styles.TransactionTo}>to</div>
                    <div className={styles.TransactionDate}>12 Jan 2024</div>
                    <div className={styles.TransactionApply}>Apply</div>
                </div> */}
            </div>

            <div className={styles.TransactionTable}>
                <div className={`${styles.TransactionTableRow} ${styles.Head}`}>
                    <div className={styles.TransactionTableCol}>
                        <div className={styles.TransactionHeadText}>Type</div>
                    </div>

                    <div className={styles.TransactionTableCol}>
                        <div className={styles.TransactionHeadText}>Transaction ID</div>
                    </div>

                    <div className={styles.TransactionTableCol}>
                        <div className={styles.TransactionHeadText}>Package Name</div>
                    </div>

                    <div className={styles.TransactionTableCol}>
                        <div className={styles.TransactionHeadText}>Mode</div>
                    </div>

                    <div className={styles.TransactionTableCol}>
                        <div className={styles.TransactionHeadText}>Validity</div>
                    </div>

                    <div className={styles.TransactionTableCol}>
                        <div className={styles.TransactionHeadText}>Package Price</div>
                    </div>

                    <div className={styles.TransactionTableCol}>
                        <div className={styles.TransactionHeadText}>Status</div>
                    </div>

                    <div className={styles.TransactionTableCol}>
                        <div className={styles.TransactionHeadText}>Date</div>
                    </div>
                </div>

                {loading ? (
                    <p>Loading...</p>
                ) : history.length === 0 ? (
                    <p>No data available</p>
                ) : (
                    history.map((data: any, index: number) => (
                        <div className={styles.TransactionTableRow} key={index}>
                            <div className={styles.TransactionTableCol}>
                                <div className={`${styles.TransactionIcon} ${styles.Whatsapp}`}></div>
                            </div>
                            <div className={styles.TransactionTableCol}>
                                {data.transactionId}
                            </div>
                            <div className={styles.TransactionTableCol}>
                                {data.packageName}
                            </div>
                            <div className={styles.TransactionTableCol}>
                                {data.orderMode==="Pay Online through Debit Card / Credit Card / Net Banking / Paytm"?"Online":"offline"}
                            </div>
                            <div className={styles.TransactionTableCol}>
                                {`${data.orderValidity} ${data.orderValidityUint}`}
                            </div>
                            <div className={styles.TransactionTableCol}>
                                {/* {`${user?.user_first_name} ${user?.user_last_name}`} */}
                                <span className="TextBold">
                                    <span className="Rupees">&#8377;</span> {data.packageAmount}
                                </span>
                            </div>
                            <div className={styles.TransactionTableCol}>
                                {data.orderStatusDisplay==="Processing"?
                                <span className={`${styles.TransactionStatusIcon} ${styles.Processing}`}></span>:
                                data.orderStatusDisplay==="Failed"?
                                <span className={`${styles.TransactionStatusIcon} ${styles.Failed}`}></span>:
                                <span className={`${styles.TransactionStatusIcon} ${styles.Success}`}></span>}
                                {data.orderStatusDisplay==="Subscribed"?"Success":data.orderStatusDisplay}
                            </div>
                            <div className={styles.TransactionTableCol}>
                                {getFormattedDate(data.orderDate)}
                            </div>
                        </div>
                    ))
                )}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {pageNo !== "1" ? (
                    <div className={styles.switchView}>
                        <button
                        className={styles.toggleView}
                        onClick={() => {
                            window.scrollTo({ top: 0, behavior: "smooth" })
                            setPageNo((parseInt(pageNo) - 1).toString())
                        }}
                        >
                        {"<"} Previous Page
                        </button>
                    </div>
                    ) : (
                    <div style={{ width: "120px" }}></div> 
                    )}
                    {nextPageAvailable && (
                    <div className={styles.switchView}>
                        <button
                        className={styles.toggleView}
                        onClick={() => 
                            // Scroll to the top of the screen
                            {window.scrollTo({ top: 0, behavior: "smooth" })
                            setPageNo((parseInt(pageNo) + 1).toString())
                        }}
                        >
                        Next Page {">"}
                        </button>
                    </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
    };
};

export default connect(mapStateToProps)(RechargeTransactionHistory);
